import { render, staticRenderFns } from "./GameVersionControl.vue?vue&type=template&id=53199258&scoped=true&"
import script from "./GameVersionControl.vue?vue&type=script&lang=ts&"
export * from "./GameVersionControl.vue?vue&type=script&lang=ts&"
import style0 from "./GameVersionControl.vue?vue&type=style&index=0&id=53199258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53199258",
  null
  
)

export default component.exports